import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Rocket } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const CTAFinal = ({ onRequestDemo, onSpeakSpecialist }) => {
  const { t } = useLang();
  return (
    <section
      id="contato"
      data-testid="cta-final-section"
      className="relative py-20 lg:py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
          className="relative rounded-3xl border border-[#1dc7e9]/30 bg-[#0b1220]/70 overflow-hidden p-8 md:p-10 lg:p-12"
          style={{
            boxShadow:
              "0 0 0 1px rgba(29,199,233,0.08), 0 30px 80px rgba(0,0,0,0.5)",
          }}
        >
          {/* Background glow + grid */}
          <div
            aria-hidden
            className="absolute -left-32 -top-32 w-[500px] h-[500px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, rgba(29,199,233,0.35) 0%, rgba(29,199,233,0.05) 45%, transparent 70%)",
              filter: "blur(40px)",
            }}
          />
          <div
            aria-hidden
            className="absolute -right-32 -bottom-32 w-[500px] h-[500px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, rgba(29,199,233,0.25) 0%, rgba(29,199,233,0.04) 45%, transparent 70%)",
              filter: "blur(40px)",
            }}
          />
          <div aria-hidden className="absolute inset-0 bg-dots opacity-15 pointer-events-none" />

          <div className="relative flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-10">
            <div className="shrink-0">
              <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-2xl border border-[#1dc7e9]/40 bg-[#1dc7e9]/10 flex items-center justify-center text-[#1dc7e9]">
                <Rocket size={32} strokeWidth={1.7} />
              </div>
            </div>

            <div className="flex-1">
              <h2 className="text-2xl sm:text-3xl lg:text-[40px] font-bold leading-[1.25] tracking-tight text-white text-balance">
                {t.cta.title}
              </h2>
              <p className="mt-4 text-[#b8c0cc] leading-relaxed max-w-2xl">
                {t.cta.description}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 lg:shrink-0">
              <button
                onClick={onRequestDemo}
                className="btn-primary inline-flex items-center justify-center gap-2 bg-[#1dc7e9] text-[#04060d] font-bold text-sm px-6 py-4 rounded-lg hover:shadow-[0_0_36px_rgba(29,199,233,0.55)] hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap"
                data-testid="cta-final-primary"
              >
                {t.cta.primary}
                <ArrowRight size={16} />
              </button>
              <button
                onClick={onSpeakSpecialist}
                className="inline-flex items-center justify-center gap-2 bg-transparent border border-[#1dc7e9]/40 text-white font-medium text-sm px-6 py-4 rounded-lg hover:bg-[#1dc7e9]/10 hover:border-[#1dc7e9]/70 transition-all duration-300 whitespace-nowrap"
                data-testid="cta-final-secondary"
              >
                {t.cta.secondary}
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTAFinal;
